import React, { type ReactNode } from 'react'

import { HtmlWithLinks } from '../HtmlWithLinks/HtmlWithLinks'
import * as S from './EnrollBanner.styled'

type RootProps = {
  children: ReactNode
}

type TitleProps = {
  children: ReactNode
}

type DescriptionProps = {
  children: string
}

type ActionsProps = {
  children: ReactNode
}

type ContentProps = {
  children: ReactNode
}

export const Root = ({ children }: RootProps) => <S.Container>{children}</S.Container>

export const Title = ({ children }: TitleProps) => <S.Title>{children}</S.Title>

export const Description = ({ children }: DescriptionProps) => (
  <S.Description>
    <HtmlWithLinks html={children} />
  </S.Description>
)

export const Actions = ({ children }: ActionsProps) => (
  <S.ButtonsContainer>{children}</S.ButtonsContainer>
)

export const Content = ({ children }: ContentProps) => <S.Content>{children}</S.Content>
